export function validarRetenciones(retenciones) {
  const errors = [];

  const retencionesList = [
    { nombre: "SUSS", valor: retenciones.retSuss },
    { nombre: "IVA", valor: retenciones.retIva },
    { nombre: "Ganancias", valor: retenciones.retGanancias },
    { nombre: "DREI", valor: retenciones.retDrei },
  ];

  retencionesList.forEach(({ nombre, valor }) => {
    if (valor && (isNaN(parseFloat(valor)) || parseFloat(valor) < 0)) {
      errors.push(`Retención ${nombre}: no puede ser negativa`);
    }
  });

  return {
    isValid: errors.length === 0,
    errors,
  };
}
